import { useEffect } from "react";
import { getStampDuty } from "../../lib/store/features/quoteData.slice";
import { useAppDispatch } from "../../hooks";

function InitStampDuty() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const init = async () => {
      await dispatch(getStampDuty());
    };
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default InitStampDuty;
